/* The five brand marks a post card wears, and the play badge that goes over a video still.
 *
 * Drawn here rather than shipped as images for the same reason every other glyph in the loader is: the
 * corner sits on somebody else's website, a second request for a 300-byte logo is a request that can be
 * slow, blocked or cached wrong, and a card that renders its picture a second after its words reads as
 * broken. These are the vendors' own marks, taken from the same 16x16 set the app uses, so the logo a
 * visitor sees above the launcher is the logo the provider saw in the manage panel.
 *
 * Every element here is built with createElementNS: an SVG inside an HTML document is only an SVG when
 * it is created in the SVG namespace, and innerHTML on a host page we do not control is a habit worth
 * not having.
 */

const svgNamespace = 'http://www.w3.org/2000/svg';

/* The marks, by the slug the payload carries. Each is one path in a 16x16 box. */
const markPaths = {
    linkedin: 'M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z',
    youtube: 'M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z',
    tiktok: 'M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z',
    instagram: 'M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334',
    x: 'M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z'
};

/**
 * The brand mark of one network, as an element that can be re-pointed at another network on every card
 * swap. Built once per card: the board rotates by swapping text and attributes, never by rebuilding
 * nodes, and a mark that was torn down and re-created would flicker where nothing else does.
 * @returns {{el: SVGElement, set: Function}} The element and the setter that points it at a slug
 */
export function createSocialMark() {
    const svg = document.createElementNS(svgNamespace, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'lw-trust-social-mark');

    const path = document.createElementNS(svgNamespace, 'path');
    path.setAttribute('fill', 'currentColor');
    svg.appendChild(path);

    /**
     * Points the mark at one network, or hides it where the slug names none this build can draw.
     * @param {string} slug - 'linkedin', 'youtube', 'tiktok', 'instagram' or 'x'
     */
    function set(slug) {
        const d = markPaths[slug];
        // Hidden rather than left empty: an SVG box with no path keeps its width and pushes the author's
        // name off centre, which reads as a logo that failed to load.
        svg.style.display = d ? '' : 'none';
        path.setAttribute('d', d || '');
        svg.dataset.network = slug || '';
    }

    return { el: svg, set: set };
}

/**
 * The play badge that sits over a video still: YouTube's own red lozenge, and for every other video
 * network the dark rounded square their players use. Which one it is comes from the card's data-network
 * attribute in CSS, so this builds one shape and the stylesheet dresses it.
 * Without it a still is a photograph, and nothing tells the visitor that a tap starts something.
 * @returns {SVGElement}
 */
export function createPlayBadge() {
    const svg = document.createElementNS(svgNamespace, 'svg');
    svg.setAttribute('viewBox', '0 0 36 26');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'lw-trust-social-play');

    const plate = document.createElementNS(svgNamespace, 'rect');
    plate.setAttribute('class', 'lw-trust-social-play-plate');
    plate.setAttribute('width', '36');
    plate.setAttribute('height', '26');
    plate.setAttribute('rx', '7');
    svg.appendChild(plate);

    const tip = document.createElementNS(svgNamespace, 'path');
    tip.setAttribute('class', 'lw-trust-social-play-tip');
    tip.setAttribute('d', 'M14.5 7.8v10.4L23.7 13z');
    svg.appendChild(tip);

    return svg;
}
